import { jsx as o, jsxs as t } from "react/jsx-runtime";
import r from "dayjs";
import e from "@mui/joy/SvgIcon";
import { BaseChip as a } from "../../common/components/BaseStyledComponents/BaseChip.js";
import { BaseTypography as n } from "../../common/components/BaseStyledComponents/BaseTypography.js";
const m = ({ icon: m2, value: s, dayLabel: i, variant: d = "soft", sx: l }) => {
  let c = "";
  const p = r().startOf("day"), f = r(s).startOf("day");
  return 1 === p.diff(f, "day") ? c = "Вчора" : -1 === p.diff(f, "day") && (c = "Завтра"), o(a, { variant: d, color: "neutral", sx: { borderRadius: "8px", ...l }, startDecorator: m2 ? o(e, { width: 20, height: 20, component: m2 }) : null, children: t(n, { level: "title-sm", children: [i ? c : "", " ", o("b", { children: "-" === s ? "-" : f.format("DD.MM.YYYY") })] }) });
};
export {
  m as DateChip,
  m as default
};
//# sourceMappingURL=DateChip.js.map
